/**
 * /custom-voices page + CustomVoices enrollment wizard localized copy.
 * Re-export shim over /locales/{en,ht,fr,es}.json (custom_voices key).
 * See /locales/README.md.
 */
import en from '../locales-shared/en.json'
import ht from '../locales-shared/ht.json'
import fr from '../locales-shared/fr.json'
import es from '../locales-shared/es.json'
import ptBR from '../locales-shared/pt-BR.json'
import zhHans from '../locales-shared/zh-Hans.json'

const COPY = {
  en: en.custom_voices,
  ht: ht.custom_voices,
  fr: fr.custom_voices,
  es: es.custom_voices,
  'pt-BR': ptBR.custom_voices,
  'zh-Hans': zhHans.custom_voices,
}

export default COPY
